<template>
  <div class="main-content">
    <div>
      <v-card class="pl-3 pr-3" style="height: 62px" outlined shaped tile>
        <v-row>
          <v-col md="3">
            <v-form autocomplete="off">
              <v-text-field
                @keydown.enter.prevent="getDataFromApi()"
                class="fs-searchfield"
                label="Pesquisar por Pedido"
                placeholder=" "
                spellcheck="false"
                v-model="textoPesquisa"
                style="border-top-left-radius: 15px;"
                append-icon="mdi-magnify"
                @click:append="getDataFromApi()"
                outlined
                dense
              />
            </v-form>
          </v-col>
          <v-col md="2">
            <v-menu
              v-model="menuDataInicial"
              :close-on-content-click="false"
              :nudge-top="48"
              :nudge-right="10"
              transition="scale-transition"
              max-width="290"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="formatDataInicial"
                  append-outer-icon="mdi-calendar"
                  label="Data Inicial"
                  placeholder=" "
                  @click:clear="dataInicial = null"
                  v-on="on"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dataInicial"
                @change="menuDataInicial = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col md="2">
            <v-menu
              v-model="menuDataFinal"
              :close-on-content-click="false"
              :nudge-top="48"
              :nudge-right="10"
              transition="scale-transition"
              max-width="290"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="formatDataFinal"
                  append-outer-icon="mdi-calendar"
                  label="Data Final"
                  placeholder=" "
                  @click:clear="dataFinal = null"
                  v-on="on"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dataFinal"
                @change="menuDataFinal = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-switch
              v-model="filtroData"
              label="Filtro por Data"
              class="mt-0 pr-2"
              color="#2A2F50"
              :value="true"
              hide-details
            ></v-switch>
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-select
              v-model="filtroPendentes"
              :items="opcoesFiltro"
              spellcheck="false"
              placeholder=" "
              style="border-bottom-right-radius: 15px;"
              height="32px"
              outlined
              dense
            ></v-select>
          </v-col>
        </v-row>
      </v-card>
      <v-card style="border-top-right-radius: 20px;" class="mt-2" outlined tile>
        <perfect-scrollbar style="max-height: 605px">
          <v-data-table
            :loading="loading"
            loading-text="Carregando, aguarde..."
            :headers="headers"
            :items="alertas.data"
            :items-per-page="limit"
            :sort-desc="sortDesc"
            hide-default-footer
            hide-action
            sort-by="id"
            item-key="id"
          >
            <template v-slot:body="{ items }">
              <tr :class="item.vista === 'S' ? '' : 'row-destaque'" id="fs-row-alertas" v-for="item in items" :key="item.id">
                <!-- <td>{{ item.id }}</td> -->
                <td @click="visualizar(item.alerta)">{{ item.alerta.ecommerce_carrinho_id.padStart('7', 0) }}</td>
                <td @click="visualizar(item.alerta)">{{ item.alerta.pessoa.nome }}</td>
                <td @click="visualizar(item.alerta)">{{ item.alerta.titulo }}</td>
                <td @click="visualizar(item.alerta)">{{ item.alerta.descricao }}</td>
                <td @click="visualizar(item.alerta)">{{ formatarDataHora(item.data_notificacao, 'L') + ' / ' + item.horario_notificacao.slice(0, 5) }}</td>
                <td @click="visualizar(item.alerta)">
                  <span v-if="item.vista === 'S'">Sim</span>
                  <span v-else>Não</span>
                </td>
                <td width="140px">
                  <!-- <v-btn @click="abrirNotificacoes(item)" icon>
                    <v-icon>mdi-calendar</v-icon>
                  </v-btn> -->
                  <!-- <v-btn class="ml-4" @click="editarAlerta(item)" icon>
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn> -->
                  <v-btn v-if="acesso.excluir" class="ml-7" @click="excluirNotificação(item)" icon>
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </perfect-scrollbar>

        <!-- FOOTER -->
        <v-row class="ml-4 mr-6 my-3" no-gutters>
          <v-col cols="12">
            <v-row align="center" justify="space-between">
              <v-card class="ml-3" flat>
                <v-btn-toggle
                  v-model="limit"
                  mandatory
                  group
                  dense
                >
                  <v-btn :value="15" class="fs-btn-limit">15</v-btn>
                  <v-btn :value="20" class="fs-btn-limit">20</v-btn>
                  <v-btn :value="25" class="fs-btn-limit">25</v-btn>
                  <v-btn :value="50" class="fs-btn-limit">50</v-btn>
                  <v-btn :value="999999999" class="fs-btn-limit">Listar Todos</v-btn>
                </v-btn-toggle>
              </v-card>
              <v-card flat>
                <v-pagination color="#2A2F50" v-model="page" :length="alertas.lastPage" total-visible="4" circle></v-pagination>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <v-dialog v-model="dialogDetalhes" max-width="1000px">
      <detalhespedido v-if="dialogDetalhes" :itemMostrarDetalhes="pedidoDoAlertaSelecionado" :fecharDetalhes="fecharDetalhes"></detalhespedido>
    </v-dialog>
  </div>
</template>

<script>
import { listFiltro, edit, del } from '@/api/alertaNotificacao' // eslint-disable-line
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: {
    detalhespedido: () => import('@/views/app/crm/listagemdepedidos/tablepedidos/dialogdetalhes')
  },
  data () {
    return {
      acesso: {
        incluir: false,
        editar: false,
        excluir: false
      },
      headers: [
        // { text: 'ID', value: 'id' },
        { text: 'PEDIDO', value: 'alerta.ecommerce_carrinho_id' },
        { text: 'USUARIO', value: 'alerta.usuario_id' },
        { text: 'TÍTULO', value: 'alerta.titulo' },
        { text: 'DESCRIÇÃO', value: 'alerta.descricao' },
        { text: 'DATA/HORA (NOTIFICAÇÃO)' },
        { text: 'VISTA', value: 'vista' },
        { text: 'AÇÕES', align: 'center' }
      ],
      opcoesFiltro: [
        { value: 'N', text: 'Alertas Pendentes' },
        { value: 'S', text: 'Alertas Vistados' },
        { value: '', text: 'Todos' }
      ],
      dataInicial: moment().startOf('month').format('YYYY-MM-DD'),
      dataFinal: moment().endOf('month').format('YYYY-MM-DD'),
      menuDataInicial: false,
      menuDataInicialFiltro: false,
      menuDataFinal: false,
      menuDataFinalFiltro: false,
      filtroData: true,
      filtroPendentes: 'N',
      pedidoDoAlertaSelecionado: null,
      dialogDetalhes: false,
      textoPesquisa: '',
      alertas: [],
      loading: true,
      sortDesc: true,
      page: 1,
      limit: 15
    }
  },
  computed: {
    ...mapState({
      confirm: state => state.global.confirm
    }),
    ...mapGetters('authData', ['loggedInUser']),
    formatDataInicial () {
      return this.dataInicial ? moment(this.dataInicial).format('L') : ''
    },
    formatDataFinal () {
      return this.dataFinal ? moment(this.dataFinal).format('L') : ''
    }
  },
  watch: {
    page: function () {
      this.getDataFromApi()
    },
    limit: function () {
      this.page = 1
      this.getDataFromApi()
    },
    filtroPendentes: function () {
      this.page = 1
      this.getDataFromApi()
    },
    dataInicial: function () {
      this.page = 1
      this.getDataFromApi()
    },
    dataFinal: function () {
      this.page = 1
      this.getDataFromApi()
    },
    filtroData: function () {
      this.page = 1
      this.getDataFromApi()
    }
  },
  mounted () {
    this.getDataFromApi()
    if ((this.loggedInUser.id === 1) || (this.loggedInUser === 2)) {
      this.acesso.excluir = true
    }
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar'
    }),
    ...mapActions({
      getPedido: 'pedidos/getPedido'
    }),
    async getDataFromApi () {
      this.loading = true
      var pesquisa = []
      if (this.textoPesquisa.length > 0) {
        pesquisa.push({ field: 'ecommerce_carrinho_id', value: parseInt(this.textoPesquisa) })
        pesquisa.push({ field: 'titulo', value: this.textoPesquisa })
        pesquisa.push({ field: 'descricao', value: this.textoPesquisa })
      }
      if (this.filtroData) {
        pesquisa.push({ field: 'dataInicial', value: this.dataInicial + ' 00:00:00' })
        pesquisa.push({ field: 'dataFinal', value: this.dataFinal + ' 23:59:59' })
      }
      const pagination = `page=${this.page}&limit=${this.limit}`
      pesquisa.push({ field: 'vista', value: this.filtroPendentes })
      this.alertas = await listFiltro('/admin/alertas-notificacoes-filtro', { tipo: 'pesquisa', query: this.querySerializePesquisa('pesquisa', pesquisa) }, pagination)
      // console.log('response: ', this.alertas)
      this.loading = false
    },
    formatarDataHora (data, format) {
      return moment(data).format(format)
    },
    async visualizar (alerta) {
      try {
        this.pedidoDoAlertaSelecionado = (await this.getPedido(alerta.ecommerce_carrinho_id))[0]
        this.dialogDetalhes = true
      } catch (error) {
        this.setSnackbar({ msg: `Ocorreu um erro! ${error}` })
      }
    },
    fecharDetalhes () {
      this.dialogDetalhes = false
    },
    async editarAlerta (item) {
      this.alertaEditModeId = item.id
      this.titulo = item.titulo
      this.alertaUsuarioId = item.usuario_id
      this.descricao = item.descricao
      this.alertaEditMode = true
      this.dialog = true
    },
    async excluirNotificação (item) {
      if (await this.confirm.open('Excluir Agendamento', 'Tem certeza que deseja excluir este agendamento?', { color: 'red' })) {
        try {
          await del({}, item.id)
          this.getDataFromApi()
          this.setSnackbar({ msg: 'Notificação Excluída com Sucesso!', color: 'green' })
        } catch (error) {
          this.setSnackbar({ msg: `Ocorreu um erro! ${error}` })
        }
      }
    },
    querySerializePesquisa (nome, filtroComposto) {
      let query = ''
      for (let i = 0; i < filtroComposto.length; i++) {
        if (i === 0) {
          query = query + nome + '%5B0%5D' + '=' + '%5B' + encodeURIComponent(JSON.stringify(filtroComposto[i]))
        } else {
          query = query + encodeURIComponent(',') + encodeURIComponent(JSON.stringify(filtroComposto[i]))
        }
      }
      return query + '%5D'
    }
  }
}
</script>

<style scoped>
  #fs-row-alertas {
    border-bottom: 1px solid rgba(0,0,0,.12);
  }
  #fs-row-alertas:hover {
    cursor: pointer;
    background-color: rgba(238, 238, 238, 0.712);
  }
  th, td {
    padding-left: 15px !important;
    padding-right: 10px !important;
  }
  th {
    height: 35px !important;
    font-size: 11px !important;
  }
  td {
    font-size: 11.5px !important;
    color: rgb(82, 82, 82);
    height: 37px !important;
  }
  .fs-searchfield .v-input__icon--append .v-icon {
    margin-top: -6px;
    font-size: 23px !important;
  }
  .fs-searchfield .v-input__icon--append .v-icon:hover {
    color: black;
  }
  textarea:focus, input:focus, select:focus, button:focus {
    box-shadow: 0 0 0 0;
    border: 0;
    outline: 0;
  }
  .row-destaque {
    font-weight: bold;
    border-left: 5px solid red;
  }
  .fs-btn-limit {
    font-size: 11px !important;
  }
  .v-input--selection-controls.v-input .v-label {
    padding-top: 9px !important;
    font-size: 12px !important;
  }
</style>
